import { render, staticRenderFns } from "./LoyalityReferralCongratulations.vue?vue&type=template&id=d56c9c22&scoped=true"
import script from "./LoyalityReferralCongratulations.vue?vue&type=script&lang=js"
export * from "./LoyalityReferralCongratulations.vue?vue&type=script&lang=js"
import style0 from "./LoyalityReferralCongratulations.vue?vue&type=style&index=0&id=d56c9c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56c9c22",
  null
  
)

export default component.exports